export const de = {
  Index: {
    owner: 'Konto Inhaber:',
    dob: 'Geburtsdatum:',
    portfolio: 'Immobilien Portfolio:',
    sign: 'Signieren',
    support: 'Support kontaktieren',
    shares: 'Anteil(e)',
    seed_phrase: 'Seed Phrase',
    seed_phrase_text: 'Seed Phrase für die Signatur',
    signed_success: 'Die Signatur war erfolgreich. Bitte dies an uns weitergeben - dann wir das Konto des Kontoinhabers wieder frei geschalten.',
    signed_error: 'Bei der Signatur kam es zu einem Fehler. Bitte kontaktiere den Support.'
  },
  CreateKey: {
    create: 'Public Key erstellen',
    copy_public: 'Kopiere den Public Key und sende ihn das Brickwise Team.',
    public_key: 'Public Key',
    further: 'Weiter',
    key_copied: 'Public Key wurde in die Zwischenablage kopiert! '
  },
  DownloadSeed: {
    download_seed: 'Seed Phrase herunterladen',
    keep_seed: 'Lade deine Seed Phrase herunter und bewahre sie sicher auf.',
    further: 'Weiter',
    key_copied: 'Deine Seed Phrase wurde erfolgreich herunterladen!',
    setup_success: 'Einrichtung erfolgreich!',
    complete: 'Fertig'
  },
  WelcomeNotary: {
    welcome: 'Willkommen bei Brickwise Notary',
    enter_code: 'Gib den Restore Code ein um die Transaktion durchzuführen.',
    error_with_key: 'Der eingegebene Restore Code ist leider falsch!',
    start_now: 'Jetzt starten'
  },
  EnableTransaction: {
    citizen: 'Staatsbürgerschaft',
    birth: 'Geburtsdatum',
    account_holder: 'Kontoinhaber:in',
    realestate: 'Immobilien Portfolio',
    address: 'Bankengasse 24, 1010 Wien',
    shares: ' Anteile',
    enable: 'Transaktion FREIGEBEN ',
    sign: 'Signieren',
    signin_success: 'Signierung erfolgreich!',
    complete: 'Fertig'
  },
  Footer: {
    support: 'Support',
    imprint: 'Impressum',
    data_protection: 'Datenschutz',
    brickwise_copy: '©Brickwise Investment GmbH'
  }
}

export default de
